import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';

import antesedepois from "../../../assets/images/1.jpeg"
import antesedepois1 from "../../../assets/images/2.jpeg"
import antesedepois2 from "../../../assets/images/3.jpeg"
import antesedepois3 from "../../../assets/images/4.jpeg"
import antesedepois4 from "../../../assets/images/5.jpeg"
import antesedepois5 from "../../../assets/images/6.jpeg"
import antesedepois6 from "../../../assets/images/7.jpeg"
import antesedepois7 from "../../../assets/images/8.jpeg"
import antesedepois8 from "../../../assets/images/9.jpeg"

const ImageCarousel = () => {
  const images = [
    {
      src: `${antesedepois}`,
    //   legend: "Legend 1",
    },
    {
      src: `${antesedepois1}`,
    //   legend: "Legend 2",
    },
    {
      src: `${antesedepois2}`,
    //   legend: "Legend 3",
    },
        {
      src: `${antesedepois3}`,
    //   legend: "Legend 3",
    },
        {
      src: `${antesedepois4}`,
    //   legend: "Legend 3",
    },
        {
      src: `${antesedepois5}`,
    //   legend: "Legend 3",
    },
        {
      src: `${antesedepois6}`,
    //   legend: "Legend 3",
    },
        {
      src: `${antesedepois7}`,
    //   legend: "Legend 3",
    },
        {
      src: `${antesedepois8}`,
    //   legend: "Legend 3",
    },
  ];

  return (
    <Carousel
      showThumbs={false}
      autoPlay
      infiniteLoop
      showStatus={false}
    >
      {images.map((image, index) => (
        <div key={index}>
          <img src={image.src} alt={image.legend} />
          {/* <p className="legend">{image.legend}</p> */}
        </div>
      ))}
    </Carousel>
  );
};

export default ImageCarousel;